"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ipm = exports.IpmClient = void 0;
const IpmClient_1 = require("./IpmClient");
const IpmMessageService_1 = require("./IpmMessageService");
var IpmClient_2 = require("./IpmClient");
Object.defineProperty(exports, "IpmClient", { enumerable: true, get: function () { return IpmClient_2.IpmClient; } });
/**
 * Factory function to create an instance of `IpmClient`.
 *
 *  Use this factory method instead of directly instantiating the `IpmClient` class.
 *  For more information, refer to the documentation of the `IpmClient` class.
 *
 * @param {AdpAnalytics} analytics - The analytics instance used for initializing the `IpmClient`.
 * @returns {IpmClient} An instance of `IpmClient` initialized with the provided analytics.
 *
 * @example
 * const analytics = new AdpAnalytics();
 * const ipmClient = Ipm(analytics);
 * ipmClient.on("messageGenerated", async (payload) => {
 *   console.log('Generated IPM message ID:', payload.id);
 *   console.log('Generated IPM message JSON Payload:', payload.jsonPayload);
 *
 *   const fetchedIpmMessage = await ipmClient.getMessage({ insightId: payload.id });
 *   console.log('Fetched IPM message:', fetchedIpmMessage);
 *   renderIpmMessage(fetchedIpmMessage);
 * });
 */
function Ipm(analytics) {
    return new IpmClient_1.IpmClient(analytics, new IpmMessageService_1.IpmMessageService({ analytics }));
}
exports.Ipm = Ipm;
